import { render, staticRenderFns } from "./KBCheck.vue?vue&type=template&id=6dc545cb&scoped=true&"
import script from "./KBCheck.vue?vue&type=script&lang=js&"
export * from "./KBCheck.vue?vue&type=script&lang=js&"
import style0 from "./KBCheck.vue?vue&type=style&index=0&id=6dc545cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc545cb",
  null
  
)

export default component.exports